import { } from '@/utils/dataFormat'
import moment from 'moment'
import { showToast } from '@/utils/common'
// import dic from '@/utils/dictionaryData'

export default {

  // 获取银行端用户基本信息
  getBankUserInfo (ctx, params) {
    return new Promise((resolve, reject) => {

    })
  },
  // 获取重客端用户基本信息
  getZkInfo (ctx, params) {
    return new Promise((resolve, reject) => {

    })
  }
}
